import React from 'react'
import IconLabel from '../../common/icon-label'
import { GeoAlt } from 'react-bootstrap-icons'
import LocationLabel from '../../locations/label'

const LocationIconLabel = ({
    experience = {}
}) => {

    return (
        <IconLabel
            icon={GeoAlt}
        >
            <LocationLabel locationId={experience.locationId} />
        </IconLabel>
    )
}

export default LocationIconLabel